<template>
	<div>
		<b-row>
			<k-crud :crudActive="userPermissions.update" :fields="fieldsStructure" :data="workflow" ref="workflowKCrud" />
		</b-row>
		<b-row class="mt-4">
			<b-col cols="12" md="3">
				<h5>{{ $t("pages.workflowDetails.workflowSteps") }}</h5>
				<b-list-group flush class="cardHeight">
					<b-list-group-item
						button
						v-for="step in steps"
						class="stepItem"
						v-bind:class="step.idStep == actualStepId ? 'font-weight-600' : 'font-weight-normal'"
						v-bind:key="step.idStep"
						@click="renderStep(step)"
					>
						<span class="stepTitle">{{ step.name }}</span>
						<k-eraser-button
							id="removerEtapaBtn"
							@click="excludeStep(step.idStep, step.nome)"
							:textTooltip="$t('buttons.erase')"
						/>
					</b-list-group-item>
					<b-list-group-item button class="stepItem" @click="newStep">
						<span class="stepTitle"><strong>+</strong> {{ $t("buttons.addStep") }}</span>
					</b-list-group-item>
				</b-list-group>
			</b-col>
			<b-col cols="12" md="9" class="border-left">
				<h5>{{ $t("pages.workflowDetails.stepInfo") }}</h5>
				<k-crud
					@fieldChange="fieldChange"
					:crudActive="userPermissions.update"
					:fields="stepStructure"
					:data="actualStep"
					ref="stepKCrud"
				/>
				<b-row>
					<b-col cols="12" class="d-flex justify-content-start">
						<b-button class="mb-3" style="padding: 0.5% 4%" variant="info" @click="handleFieldObrigatorityClick">
							{{ $t("pages.workflowDetails.fieldMandatories") }}
						</b-button>
					</b-col>
				</b-row>
				<hr v-if="actualStep.retentionStep" class="hr-top" />
				<h5 v-if="actualStep.retentionStep">{{ $t("pages.workflowDetails.retentionSteps") }}</h5>
				<div v-if="actualStep.retentionStep">
					<b-col
						v-for="(retentionStepId, index) in actualStep.retentionStepsId"
						v-bind:key="retentionStepId"
						cols="4"
						class="selectList marginClass"
					>
						<b-form-group :label="this.$t('pages.workflowDetails.retentionStep')">
							<b-form-select
								class="exitsList"
								type="dropdown"
								:options="getStepsWithoutSelected(retentionStepId)"
								v-model="actualStep.retentionStepsId[index]"
								text-field="name"
								value-field="idStep"
							></b-form-select>
						</b-form-group>
						<b-icon
							v-if="!onlyOneRetentionStep"
							icon="trash"
							class="trash-icon"
							@click="deleteDestinationStep(retentionStep)"
						/>
					</b-col>
				</div>
				<div v-if="actualStep.retentionStep" class="addDestinationStep" @click="addDestinationStep">
					<b-icon icon="plus-circle" class="addDestinationIcon" />
					{{ $t("modals.newAction.addNewDestinationStep") }}
				</div>
				<hr v-if="actualStep.retentionStep" />

				<h5>{{ $t("pages.workflowDetails.actionsDestinations") }}</h5>
				<k-list
					v-if="actions.length != 0"
					:items="actions"
					:fields="fields"
					:editPermission="userPermissions.update"
					:deletePermission="userPermissions.delete"
					excludeButton
					editButton
					@actionEditar="renderEditActionModal"
					@actionExcluir="excludeAction"
				/>
				<k-info-box v-if="actions.length == 0" :closeButton="false" :info="infoBoxObj" />
				<new-action-modal
					ref="newActionModal"
					:type="modalActionType"
					:steps="stepsWithoutCurrent"
					:actualStep="actualStep"
					@newAction="newAction"
					@editAction="editAction"
				/>
				<k-include-button
					id="adicionarBtn"
					@click="renderNewActionModal"
					:disabled="disableSystemStep"
					:text="$t('commons.add')"
				/>
			</b-col>
		</b-row>
		<k-modal
			ref="noEditStepModal"
			id="noEditStepModal"
			:title="this.$t('commons.attention')"
			:okTitle="$t('buttons.ok')"
			okVariant="info"
			:okOnly="true"
			size="md"
			:message="$t('pages.workflowDetails.modals.noEditStep.message')"
		/>
		<k-modal
			:onOk="saveWorkflow"
			ref="confirmMessage"
			id="confirmMessage"
			:title="this.$t('commons.attention')"
			:okTitle="$t('buttons.ok')"
			okVariant="info"
			:okOnly="true"
			size="md"
			:message="`${
				stepsWithoutExits.length > 1
					? this.$t('pages.workflowDetails.modals.confirm.steps', [stepsWithoutExits.join(', ')])
					: this.$t('pages.workflowDetails.modals.confirm.step', [stepsWithoutExits.join(', ')])
			}`"
		/>
		<b-row class="mt-4">
			<b-col cols="12">
				<k-button
					:text="$t('buttons.save')"
					:disabled="!canEdit"
					class="btn-salve"
					@click="checkDefaultExits"
					variant="info"
				/>
				<k-button :text="$t('buttons.back')" class="float-right" @click="backBtn" variant="outline-info" />
			</b-col>
		</b-row>
		<field-obrigatority-modal ref="fieldObrigatorityModal" :actualStep="actualStep" />
	</div>
</template>

<script>
import KCrud from "../../components/ui/KCrud.vue";
import KList from "../../components/ui/KList.vue";
import KInfoBox from "../../components/ui/KInfoBox.vue";
import NewActionModal from "../../components/modals/NewActionModal.vue";
import { mapActions, mapGetters } from "vuex";
import ModalMixin from "@/mixins/ModalMixin";
import KButton from "../../components/ui/Buttons/KButton.vue";
import KIncludeButton from "../../components/ui/Buttons/KIncludeButton.vue";
import KEraserButton from "../../components/ui/Buttons/KEraserButton.vue";
import KModal from "../../components/modals/KModal.vue";
import FieldObrigatorityModal from "../../components/modals/FieldObrigatorityModal.vue";

export default {
	props: {
		id: { type: String },
		canEdit: { type: Boolean, default: true }
	},
	mixins: [ModalMixin],
	components: {
		KCrud,
		KList,
		NewActionModal,
		KInfoBox,
		KIncludeButton,
		KButton,
		KEraserButton,
		KModal,
		FieldObrigatorityModal
	},
	data() {
		return {
			infoBoxObj: {
				title: this.$t("pages.workflowDetails.infoBox.title"),
				message: this.$t("pages.workflowDetails.infoBox.message"),
				show: true
			},
			modalActionType: "new",
			actualStepId: 1,
			modalExcludeStepConfigs: {
				message: this.$t("pages.workflowDetails.modals.excludeStep.message"),
				title: this.$t("pages.workflowDetails.modals.excludeStep.title"),
				okTitle: this.$t("buttons.exclude"),
				cancelTitle: this.$t("buttons.cancel")
			},
			modalExcludeActionConfigs: {
				message: this.$t("pages.workflowDetails.modals.excludeAction.message"),
				title: this.$t("commons.attention"),
				okTitle: this.$t("buttons.exclude"),
				cancelTitle: this.$t("buttons.cancel")
			},
			actionIndex: 1,
			stepsWithoutExits: [],
			workflowApplication: [],
			workflowFamiliesFilter: [],
			supplierStatuses: []
		};
	},
	methods: {
		...mapActions([
			"getWorkflowDetails",
			"editWorkflow",
			"getActorsIncludeSupplier",
			"getStepFields",
			"getAllSupplierStatus"
		]),
		backBtn: function () {
			this.$router.push({ name: "workflow" });
		},
		renderNewActionModal: function () {
			this.modalActionType = "new";
			const activeActors = this.actors.filter((actor) => this.isEligibleActor(actor));
			const actionData = {
				idStepAction: this.getLastIdStepAction() + 1,
				actors: activeActors
			};
			this.$refs.newActionModal.setActionOnModal(actionData);
			this.$refs.newActionModal.setStandartActionOnModal(this.haveStandartAction);
			this.$bvModal.show("newActionModal");
		},
		actualStepIsIntegrationStep() {
			const isIntegrationStep = this.workflowDetails.steps.some((step) =>
				step.actions.some(
					(action) =>
						action.type.toLowerCase() === "integration" &&
						action.destinations.some((destination) => destination.idStep === this.actualStep.idStep)
				)
			);

			return isIntegrationStep;
		},
		getLastIdStepAction: function () {
			let maxIdStepAction = 0;
			if (this.actualStep.actions.length > 0) {
				this.actualStep.actions.forEach((action) => {
					if (action.idStepAction > maxIdStepAction) maxIdStepAction = action.idStepAction;
				});
			}
			return maxIdStepAction;
		},
		fieldChange: function (fieldName) {
			if (fieldName == "initialStep" && this.actualStep.initialStep) {
				this.haveInitialStep().then(() => {
					this.actualStep.initialStep = false;
					this.$functions.displayError(this, this.$t("pages.workflowDetails.error.initialStepAlreadyExists"));
				});
			}
			if (fieldName == "sendInvite" && this.actualStep.sendInvite) {
				this.checkSendInvite().then(() => {
					this.actualStep.sendInvite = false;
					this.$functions.displayError(this, this.$t("pages.workflowDetails.error.sendInviteStepAlreadyExists"));
				});
			}
		},
		haveInitialStep() {
			return new Promise((resolve) => {
				this.workflowDetails?.steps.forEach((step) => {
					if (step.idStep != this.actualStep.idStep && step.initialStep) {
						resolve();
					}
				});
			});
		},
		checkSendInvite() {
			return new Promise((resolve) => {
				this.workflowDetails.steps.forEach((step) => {
					if (step.idStep != this.actualStep.idStep && step.sendInvite) {
						resolve();
					}
				});
			});
		},
		handleFieldObrigatorityClick: function () {
			const dataObject = { stepFields: this.actualStep.stepFields };
			this.$refs.fieldObrigatorityModal.setFieldObrigatorityProperties(dataObject);
			this.$bvModal.show("fieldObrigatorityModal");
		},
		renderEditActionModal: function (action) {
			this.modalActionType = "edit";
			let actualAction = this.actualStep.actions.find((a) => a.idStepAction == action.idStepAction);
			actualAction.actors = this.actors.filter((actor) => this.isEligibleActor(actor));
			this.$refs.newActionModal.setActionOnModal(actualAction);
			this.$refs.newActionModal.setStandartActionOnModal(this.haveStandartAction);
			this.$bvModal.show("newActionModal");
		},
		isEligibleActor: function (actor) {
			return actor.isActive && actor.id > 0 && actor.id != this.actualStep?.actor?.id;
		},
		checkDefaultExits: function () {
			this.stepsWithoutExits = [];
			for (let index = 0; index < this.workflowDetails.steps.length; index++) {
				const step = this.workflowDetails.steps[index];
				let hasDefaultStep = false;

				for (let index = 0; index < step.actions.length; index++) {
					const action = step.actions[index];
					if (action.standartAction) hasDefaultStep = true;
				}
				if (!hasDefaultStep) {
					this.stepsWithoutExits.push(step.name);
				}
			}

			if (this.stepsWithoutExits.length > 0) {
				this.$bvModal.show("confirmMessage");
				return false;
			}
			return this.saveWorkflow();
		},
		saveWorkflow() {
			let workflowOk = this.$refs.workflowKCrud.validateAllFields();
			let stepOk = this.$refs.stepKCrud.validateAllFields();
			let isInitialStepOK = false;
			var stepList = this.workflowDetails.steps;
			let isDestinationMissing = false;
			let nameStepMissing = "";
			let hasConcludedType = false;
			const anyWorkflowApplicationIsTrue = this.workflowApplication.some((a) => a.label === true);

			this.workflowDetails.isSupplier = this.getWorkflowApplicationLabel(this.$WorkflowApplication.SUPPLIER);
			this.workflowDetails.isCustomer = this.getWorkflowApplicationLabel(this.$WorkflowApplication.CUSTOMER);
			this.workflowDetails.isManufactor = this.getWorkflowApplicationLabel(this.$WorkflowApplication.MANUFACTOR);
			this.workflowDetails.workflowFamiliesFilter = this.workflowFamiliesFilter
				.filter((family) => family?.label)
				.map((family) => ({
					idFamily: family.id,
					nameFamily: family.name,
					selected: family?.label
				}));

			this.workflowDetails.steps.forEach((step) => {
				if (step.initialStep) {
					isInitialStepOK = true;
				}
				if (step.actor == null) {
					this.$functions.displayError(this, this.$t("pages.workflowDetails.error.missingActorInStep", [step.name]));
				}
				step.actions.forEach((action) => {
					if (action.type == this.$ActionType.Step) {
						let idStep = action.destinations[0]?.idStep;
						let foundStep = false;

						stepList.forEach((step) => {
							if (step.idStep == idStep) foundStep = true;
						});
						if (!foundStep) {
							nameStepMissing = step.name;
							isDestinationMissing = true;
							return;
						}
					}
					if (action.type === this.$ActionType.Concluded) {
						hasConcludedType = true;
					}
				});
			});

			if (!hasConcludedType) {
				this.$functions.displayError(this, this.$t("messages.completedOutputWorkflowNotFound"));
				return;
			}

			// Caso o ator seja Sistema (-2) desconsidera o SLA
			for (let i = 0; i < this.workflowDetails.steps.length; i++) {
				if (this.workflowDetails.steps[i].actor.id < 0) {
					this.workflowDetails.steps[i].maximumDurationInHours = 0;
				}
			}

			if (stepList.length != 0) {
				if (workflowOk && stepOk && isInitialStepOK && !isDestinationMissing && anyWorkflowApplicationIsTrue) {
					this.editWorkflow()
						.then(() => {
							this.$functions.displaySuccess(this, this.$t("messages.savedChanges"));
							this.$router.push({
								name: "workflow",
								params: {}
							});
						})
						.catch((error) => {
							if (error.code) {
								this.$functions.displayError(this, this.$t(error.code));
							} else {
								this.$functions.displayError(this, this.$t("messages.changesCouldNotBeSaved"));
							}
						});
				} else {
					if (isInitialStepOK == false) {
						this.$functions.displayError(this, this.$t("pages.workflowDetails.error.initialStepIsMandatory"));
					} else if (isDestinationMissing) {
						this.$functions.displayError(
							this,
							this.$t("pages.workflowDetails.error.stepWithoutDestination", [nameStepMissing])
						);
					} else if (!anyWorkflowApplicationIsTrue) {
						this.$functions.displayError(this, this.$t("pages.workflowDetails.error.applicationIsMandatory"));
					} else {
						this.$functions.displayError(this, this.$t("messages.emptyMandatoryFields"));
					}
				}
			} else {
				this.$functions.displayError(this, this.$t("pages.workflowDetails.error.emptySteps"));
			}
		},
		newStep() {
			let newStep = {
				idStep: this.getLastStepId() + 1,
				name: this.$t("pages.workflowDetails.newStep"),
				actions: [],
				maximumDurationInHours: 1,
				sendInvite: false,
				sendEmail: false,
				initialStep: false,
				retentionStepsId: [],
				retentionStep: false,
				haveActiveInvite: false,
				registeredIdStep: 0,
				IsNewStep: true,
				updatedStepFields: false,
				stepFields: this.inviteFields.map((field) => ({
					idInviteField: field.id,
					idStep: 0,
					visualizationType:
						field.idTab === this.$InviteFieldTab.BANK_DATA
							? this.$StepFieldVisualizationType.DISABLED
							: this.$StepFieldVisualizationType.OPTIONAL
				}))
			};
			this.workflowDetails.steps.push(newStep);
			this.actualStepId = newStep.idStep;
		},
		getLastStepId() {
			let lastStepId = 0;
			this.workflowDetails.steps.forEach((step) => {
				step.idStep > lastStepId ? (lastStepId = step.idStep) : "";
			});
			return lastStepId;
		},
		newAction(action) {
			this.actualStep.actions.push(action);
		},
		editAction(action) {
			let index = this.actualStep.actions.findIndex((a) => a.idStepAction == action.idStepAction);
			this.actualStep.actions.splice(index, 1, action);
		},
		excludeAction(data) {
			this.excluirModal(this.modalExcludeActionConfigs, data.name).OK(() => {
				let index = this.actualStep.actions.findIndex((action) => action.idStepAction == data.idStepAction);
				this.actualStep.actions.splice(index, 1);
			});
		},
		excludeStep: function (idStep, name) {
			let stepToEdit = this.workflowDetails.steps.filter((step) => step.idStep === idStep)[0];
			if (stepToEdit.haveActiveInvite) {
				this.$bvModal.show("noEditStepModal");
				return;
			}
			this.excluirModal(this.modalExcludeStepConfigs, name).OK(() => {
				for (let i = 0; i < this.workflowDetails.steps.length; i++) {
					if (this.workflowDetails.steps[i].idStep == idStep) {
						this.workflowDetails.steps.splice(i, 1);
						this.actualStepId = this.workflowDetails.steps[0].idStep;
					}
				}
			});
		},
		renderStep: function (step) {
			this.actualStepId = step.idStep;
		},
		getStepsWithoutSelected: function (actualSelected) {
			return this.stepsWithoutCurrent.filter(
				(step) => this.actualStep.retentionStepsId.indexOf(step.idStep) == -1 || step.idStep == actualSelected
			);
		},
		addDestinationStep: function () {
			this.actualStep.retentionStepsId.push(0);
		},
		deleteDestinationStep: function (idDestinationStep) {
			let index = this.actualStep.retentionStepsId.indexOf(idDestinationStep);
			this.actualStep.retentionStepsId.splice(index, 1);
		},
		mapWorkflowAplication() {
			const { clientModules, isCustomer, isSupplier, isManufactor } = this.workflowDetails;
			const { CUSTOMER, SUPPLIER, MANUFACTOR } = this.$WorkflowApplication;

			if (clientModules.customer) {
				this.workflowApplication.push(
					{ id: CUSTOMER, name: this.$t("pages.workflowDetails.application.client"), label: isCustomer },
					{ id: SUPPLIER, name: this.$t("pages.workflowDetails.application.supplier"), label: isSupplier }
				);
			}

			if (clientModules.manufactor) {
				this.workflowApplication.push({
					id: MANUFACTOR,
					name: this.$t("pages.workflowDetails.application.manufactor"),
					label: isManufactor
				});
			}
		},
		mapWorkflowFamiliesFilter() {
			const { workflowFamiliesFilter } = this.workflowDetails;
			if (workflowFamiliesFilter && workflowFamiliesFilter.length > 0) {
				this.workflowFamiliesFilter = workflowFamiliesFilter.map((family) => ({
					id: family.idFamily,
					name: family.nameFamily,
					label: family.selected
				}));
			}
		},
		getWorkflowApplicationLabel(application) {
			return this.workflowApplication.find((wfa) => wfa.id == application)?.label ?? false;
		}
	},
	computed: {
		...mapGetters(["loading", "userPermissions", "workflowDetails", "actors", "inviteFields", "actualUser"]),
		fieldsStructure: function () {
			const hasSupplierStatuses = this.supplierStatuses.length > 0;

			let fieldsStructure = [
				{
					rowNum: 0,
					width: "3",
					name: "name",
					label: this.$t("pages.workflowDetails.workflowName"),
					type: "text",
					validation: this.$validations.required
				},
				{
					rowNum: 0,
					width: hasSupplierStatuses ? "2" : "3",
					label: this.$t("commons.application"),
					text: this.$t("pages.workflowDetails.applicateTo"),
					type: "dropdownCheckbox",
					name: "workflowApplication",
					entityList: this.workflowApplication
				},
				{
					rowNum: 0,
					width: "3",
					label: this.$t("pages.workflowDetails.familiesFilter"),
					text: this.$t("commons.placeholders.selectFamilies"),
					type: "dropdownCheckbox",
					name: "workflowFamiliesFilter",
					entityList: this.workflowFamiliesFilter
				},
				{
					rowNum: 0,
					width: hasSupplierStatuses ? "2" : "3",
					label: this.$t("commons.status"),
					type: "dropdown",
					name: "isActive",
					valueKey: "value",
					valueText: "text",
					returnKey: true,
					validation: this.$validations.required,
					options: [
						{ value: this.$IsActive.ACTIVE, text: this.$t("commons.active") },
						{ value: this.$IsActive.INACTIVE, text: this.$t("commons.inactive") }
					]
				}
			];

			if (hasSupplierStatuses) {
				fieldsStructure.push({
					rowNum: 0,
					width: "2",
					label: this.$t("pages.workflowDetails.supplierStatus"),
					type: "dropdown",
					name: "supplierStatus",
					valueKey: "value",
					valueText: "text",
					returnKey: true,
					options: this.supplierStatuses
				});
			}

			return fieldsStructure;
		},
		stepStructure: function () {
			this.$setMinMax(0, 100);
			const activeActors = this.actors.filter((actor) => actor.isActive);

			let stepStructure = [
				{
					rowNum: 0,
					width: "6",
					label: this.$t("pages.workflowDetails.stepName"),
					name: "name",
					type: "text",
					validation: this.$validations.required
				},
				{
					rowNum: 0,
					width: "6",
					label: this.$t("commons.actor"),
					name: "actor",
					type: "dropdown",
					valueKey: "id",
					valueText: "name",
					options: activeActors
				},
				{
					rowNum: 1,
					width: "2",
					label: this.$t("pages.workflowDetails.sendInvite"),
					name: "sendInvite",
					type: "switch"
				},
				{
					rowNum: 1,
					width: "2",
					label: this.$t("pages.workflowDetails.initialStep"),
					name: "initialStep",
					type: "switch"
				},
				{
					rowNum: 1,
					width: "2",
					label: this.$t("pages.workflowDetails.sendEmail"),
					name: "sendEmail",
					type: "switch",
					isVisible: this.actualStep?.initialStep
				},
				{
					rowNum: 1,
					width: "2",
					label: this.$t("pages.workflowDetails.retentionStep"),
					name: "retentionStep",
					type: "switch"
				},
				{
					rowNum: 1,
					width: "6",
					label: this.$t("pages.workflowDetails.stepSLA"),
					name: "maximumDurationInHours",
					type: "number",
					isVisible: this.actualStep?.actor?.id > 0,
					min: 0,
					max: Infinity,
					validation: this.actualStep?.actor?.id > 0 ? this.$validations.number : false
				}
			];

			return stepStructure;
		},
		workflow() {
			let workflowDetails = this.workflowDetails;
			return workflowDetails;
		},
		steps() {
			return this.workflowDetails.steps ? this.workflowDetails.steps : [];
		},
		stepsWithoutCurrent() {
			return this.workflowDetails.steps
				? this.workflowDetails.steps.filter((step) => step.idStep != this.actualStepId)
				: [];
		},
		actualStep() {
			let step = {};
			if (this.workflowDetails.steps) {
				step = this.workflowDetails.steps.find((step) => step.idStep == this.actualStepId);
			}
			return step;
		},
		haveStandartAction() {
			let response = false;
			this.actualStep.actions.forEach((action) => {
				if (action.standartAction) {
					response = true;
				}
			});

			return response;
		},
		actions() {
			return this.actualStep.actions ? this.actualStep.actions : [];
		},
		disableSystemStep() {
			if (!this.actualStep.actor) return false;

			const { id } = this.actualStep.actor;
			const { actions } = this.actualStep;

			switch (id) {
				case this.$FillerActor.PUBLIC_CONSULTATIONS_ACTOR:
					return actions.length > 0;
				case this.$FillerActor.INTEGRATION_ACTOR:
					return actions.length === 2;
				default:
					return false;
			}
		},
		fields() {
			const actionType = this.$ActionType;
			return [
				{
					key: "name",
					label: this.$t("pages.workflowDetails.actionName")
				},
				{
					key: "destinations",
					label: this.$t("commons.destination"),
					getProp: (value, state) => {
						if (value.type != actionType.Step && value.type != actionType.Returned) return "-";
						let steps = state.workflowDetails.steps.filter((step) => {
							return value.destinations.filter((d) => d.idStep == step.idStep).length > 0;
						});
						return steps.map((s) => s.name).join(", ");
					}
				}
			];
		}
	},
	beforeMount() {
		this.getActorsIncludeSupplier();
		this.getAllSupplierStatus().then(({ statuses }) => {
			this.supplierStatuses = statuses.map((s) => ({
				value: s.id,
				text: s.description
			}));
		});

		const paramsObject = {
			id: this.id,
			idClient: this.actualUser.idClient
		};
		this.getWorkflowDetails(paramsObject).then(() => {
			this.actualStepId = this.workflowDetails.steps[0].idStep;
			this.mapWorkflowFamiliesFilter();
			this.mapWorkflowAplication();
		});
		this.$nextTick(function () {
			var element = this.$el.querySelector('[name="nome"]');
			if (element) element.focus();
		});
	}
};
</script>

<style scoped>
.btn-salve {
	float: right;
	margin-left: 16px;
}
.addDestinationStep {
	cursor: pointer;
	margin-inline: 17px;
}
.addDestinationStep:hover {
	font-weight: 500;
	color: black;
}
#adicionarBtn {
	float: right;
}
.stepItem {
	padding: 0.55rem 0.25rem;
	display: flex;
	align-items: center;
	padding: 0 4px;
	height: 32px;
}
.border-left {
	border: 0px solid #ededed;
	border-left-width: 1px;
}
.stepTitle {
	flex-grow: 1;
	color: #1c1637;
}
.font-weight-600 {
	font-weight: 600;
}
.cardHeight {
	max-height: 45vh;
	overflow: auto;
}
.custom-control-inline .custom-control-label::after {
	margin-top: 5px;
}
.custom-control-inline .custom-control-label::before {
	margin-top: 5px;
}
h5 {
	font-size: 14px;
	font-weight: 400;
	color: #1c1637;
}
.hr-top {
	margin-top: 0px !important;
	margin-bottom: 6px !important;
}
.marginClass {
	margin-inline: 0px !important;
}
</style>
